import { render, staticRenderFns } from "./Medicamentos.vue?vue&type=template&id=1c82ba20"
import script from "./Medicamentos.vue?vue&type=script&lang=js"
export * from "./Medicamentos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports